// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oF6f","questions":"styles_questions__3yX2X","footer":"styles_footer__3zjv1"};